import React from 'react';
import { Helmet } from 'react-helmet';
import defaultSeoImage from '../../../public/default_seo.png';

/* Sad times. Helmet doesn't allow Fragment children, hence the ugly code you will see below. :( */

const SEOHelmet = ({ seo, origin, language, region, children }) => {
  if (!seo) {
    return <Helmet>{children}</Helmet>;
  }
  const USPage =
    (seo.globalName || seo.allHrefs) &&
    (seo.globalName || seo.allHrefs).find(x => x.locale === 'en-US');

  const seoImage = seo.image ? seo.image : defaultSeoImage;
  return (
    <Helmet titleTemplate={seo.titlePattern || null}>
      <html
        lang={seo.language}
        itemScope
        itemType="http://schema.org/Article"
      />
      {language && region && (
        <meta httpEquiv="content-language" content={`${language}-${region}`} />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@formlabs" />
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Formlabs" />
      {seo.title && <title>{seo.title}</title>}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.title && <meta itemProp="name" content={seo.title} />}
      {seo.description && <meta name="description" content={seo.description} />}
      {seo.description && (
        <meta itemProp="description" content={seo.description} />
      )}
      {(seo.description || seo.twitterDescription) && (
        <meta
          name="twitter:description"
          content={seo.twitterDescription || seo.description}
        />
      )}
      {(seo.description || seo.ogDescription) && (
        <meta
          property="og:description"
          content={seo.ogDescription || seo.description}
        />
      )}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      <meta itemProp="image" content={seoImage} />
      <meta name="twitter:image:src" content={seoImage} />
      <meta property="og:image" content={seoImage} />
      {seo.noIndex && <meta name="robots" content="noindex" />}
      {seo.canonical && origin && (
        <link rel="canonical" href={origin + seo.canonical} />
      )}
      {(seo.globalName || seo.allHrefs) &&
        (seo.globalName || seo.allHrefs).map(x => (
          <link
            key={x.locale}
            rel="alternate"
            href={x.path}
            hrefLang={x.locale}
          />
        ))}
      {USPage && (
        <link rel="alternate" href={USPage.path} hrefLang="x-default" />
      )}
      {children}
    </Helmet>
  );
};

export default SEOHelmet;
